import React from 'react';
import { isTerminalVertical } from '../../utils';
import styles from './CloseButton.styles';
import Button from '../Button';

class CloseButton extends React.Component {
  render() {
    const { onClick } = this.props;
    return (
      <div
        className='row'
        style={{
          zIndex: 10,
          position: 'absolute',
          right: '0px'
        }}
      >
        <Button
          className={`close text-secondary ${isTerminalVertical() && 'pt-2 pr-3'}`}
          onClick={() => {
            onClick();
          }}
        >
          <svg
            width='1.2em'
            height='1.2em'
            viewBox='0 0 16 16'
            className='bi bi-x'
            fill='currentColor'
            xmlns='http://www.w3.org/2000/svg'
            style={
              isTerminalVertical()
                ? {
                    ...styles.commonStyle,
                    ...styles.verticalTerminalStyle
                  }
                : { ...styles.commonStyle }
            }
          >
            <path
              fillRule='evenodd'
              d='M11.854 4.146a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708-.708l7-7a.5.5 0 0 1 .708 0z'
            />
            <path
              fillRule='evenodd'
              d='M4.146 4.146a.5.5 0 0 0 0 .708l7 7a.5.5 0 0 0 .708-.708l-7-7a.5.5 0 0 0-.708 0z'
            />
          </svg>
        </Button>
      </div>
    );
  }
}

export default CloseButton;
